import { CoordinatorService } from './coordinator.service';
import { Evidence } from './evidence';
import { Notepad } from './notepad';
import { ScriptNotepadItem } from './script-notepad-item';

export class NotepadItem {
    id: string;
    private _title = '';
    private _body = '';

    order: number;
    evidence: Evidence;

    constructor(
        private coords: CoordinatorService,
        public notepad: Notepad,
        params: any,
    ) {
        this.id = params.id || this.coords.uniqueId();
        this._body = params.body || '';
        this._title = params.title || this._body.slice(0, 30);
        this.order = params.order || 0;
        this.evidence = new Evidence(this.coords, this, params.evidence || {});
    }

    hasEvidence(arg: string | { id: string }) {
        return !!this.evidence.isOn(arg);
    }

    pdfDialog() {
        this.coords.display$.dialog$.next({
            action: 'pdf',
        });
    }

    hasText(txt: string, includeEvidence = true) {
        const u$ = this.coords.utils$;
        if (u$.htmlIncludesText(txt, this.title) || u$.htmlIncludesText(txt, this.body))
            return true;
        if (includeEvidence && this.evidence.hasText(txt)) return true;
        return false;
    }

    public get title(): string {
        if (!this._title) {
            return this.coords.utils$.htmlTextContent(this.body).slice(0, 30);
        }
        return this._title;
    }
    public set title(value: string) {
        this._title = value;
        this._store();
    }
    public get body(): string {
        return this._body;
    }
    public set body(value: string) {
        if (!value) return;
        value = value.trim();
        const prefix = '<p><br></p>';
        while (value.startsWith(prefix)) value = value.slice(prefix.length);
        const v = value.trim();
        if (this._body === v) return;
        this._body = v;
        this._store();
    }

    private _store() {
        this.coords.display$.markForCheck();
        this.notepad.markForManifestStore();
    }

    delete() {
        this.notepad.deleteItem(this);
    }

    save() {
        return {
            id: this.id,
            title: this.title,

            body: this._body,
            order: this.order,
            evidence: this.evidence.save(),
        };
    }

    get selectorText() {
        return `<b>${this.title}: </b> ${this.coords.utils$.htmlTextContent(this.body)}`;
    }

    get scriptClass() {
        return new ScriptNotepadItem(this.coords, this);
    }

    markForManifestStore() {
        this.notepad.markForManifestStore();
    }
}
